import React from 'react';
import { faqs } from '../data/mockData';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { motion } from 'framer-motion';

const FAQSection = () => (
  <section id="faq" className="py-24 md:py-32 bg-stone-50 overflow-hidden">
    <div className="max-w-4xl mx-auto px-6 lg:px-8">
      <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6 }} className="text-center mb-16">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-orange-600 block mb-4">FAQ</span>
        <h2 className="font-serif text-4xl sm:text-5xl tracking-tight text-stone-900">Common Questions.<br/><span className="italic text-emerald-900">Straight Answers.</span></h2>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-50px" }} transition={{ duration: 0.6, delay: 0.15 }}>
        <Accordion type="single" collapsible data-testid="faq-accordion">
          {faqs.map((faq) => (
            <AccordionItem key={faq.id} value={`item-${faq.id}`} className="border-b-2 border-stone-200 last:border-b-0">
              <AccordionTrigger className="text-left text-lg font-sans font-bold text-stone-900 hover:text-emerald-900 py-6 transition-colors [&[data-state=open]]:text-emerald-900">{faq.question}</AccordionTrigger>
              <AccordionContent className="text-stone-500 text-sm leading-relaxed pb-6">{faq.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </motion.div>
    </div>
  </section>
);
export default FAQSection;
